// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3Tv4D","header":"PatientBlock_header__3Ro2v","label":"PatientBlock_label__MsAIS","option":"PatientBlock_option__2_JYO"};